'use client';

import React__default from 'react';
import Col from '../../../LayoutSystem/Col.js';
import '../../../LayoutSystem/Row.js';
import { colors } from '../../../Colors/index.js';
import Typography from '../../../Typography/index.js';
import { CustomRadio, LabelRadio, ImageWrap } from '../../styles.css.js';

var Radio = function (_a) {
    var title = _a.title, value = _a.value, description = _a.description, image = _a.image, onChange = _a.onChange, name = _a.name, _b = _a.layout, layout = _b === void 0 ? 'col' : _b;
    var renderLabel = function () {
        return (React__default.createElement(LabelRadio, { gutter: 16 },
            React__default.createElement(Col, { xs: layout === 'col' ? 24 : 'auto' },
                React__default.createElement(ImageWrap, null,
                    React__default.createElement("img", { src: image, alt: 'icon' }))),
            React__default.createElement(Col, { xs: layout === 'col' ? 24 : 'fill' },
                React__default.createElement(Typography, { variant: 'p', name: 'title', size: 'extraLarge', color: colors.primary[0], style: { textAlign: 'center' } }, title),
                React__default.createElement(Typography, { variant: 'p', name: 'paragraph', size: 'medium', color: colors.primary[0], style: { whiteSpace: 'pre-wrap', marginTop: 8, textAlign: 'center' } }, description))));
    };
    return (React__default.createElement(CustomRadio, { id: "".concat(name, "-radio"), name: name, customValue: renderLabel(), isCustomLabel: true, onChange: onChange, checked: value, isActive: value }));
};

export { Radio };
//# sourceMappingURL=Radio.js.map
